import {modifyPageLayoutComponents} from '../PageLayout';

import {
  FeatureCreatorContainerNew,
  FeatureCreatorPageFooter,
  FeatureCreatorPageHeaderContainerNew
} from "./FeatureCreatorNew";

export {FeatureCreatorCard} from './FeatureCreatorCard';

export const FeatureCreatorLayoutNewComponents = modifyPageLayoutComponents({
  pageHeader: FeatureCreatorPageHeaderContainerNew,
  content: FeatureCreatorContainerNew,
  pageFooter: FeatureCreatorPageFooter
});
